import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { format, subDays, startOfMonth, endOfMonth, startOfYear } from 'date-fns';
import { Icon } from '../Icon';
import { OverLay } from '../Others';

import style from "../../Style/Component/input.module.scss";
import { PrimaryButton, SecondaryButton } from '../Buttons';



const DateRangePicker = (props) => {
    const today = new Date();

    const getThisMonthEnd = () => {
        if (props.maxDate) return props.maxDate;
        return endOfMonth(today);
    };

    const getThisYearEnd = () => {
        if (props.maxDate) return props.maxDate;
        return today;
    };

    const parseInceptionDate = (value) => {
        if (!value || typeof value !== 'string') return null;
        const [year, month, day] = value.split('-').map(Number);
        if (!year || !month || !day) return null;
        return new Date(year, month - 1, day);
    };

    const inceptionStart = parseInceptionDate(props.inceptionDate);

    const RANGE_DATA = [
        { id: 1, label: 'Today', range: [today, today] },
        // { id: 2, label: 'Yesterday', range: [subDays(today, 1), subDays(today, 1)] },
        // { id: 3, label: 'Last 7 days', range: [subDays(today, 6), today] },
        {
            id: 4,
            label: 'This month',
            range: [
                startOfMonth(today),
                getThisMonthEnd()
            ]
        },
        { id: 5, label: 'Last 30 days', range: [subDays(today, 29), today] },
        {
            id: 7,
            label: 'This year',
            range: [
                startOfYear(today),
                getThisYearEnd()
            ]
        },
        ...(inceptionStart ? [{
            id: 8,
            label: 'Inception to Today',
            range: [inceptionStart, getThisYearEnd()]
        }] : []),
        { id: 6, label: 'Custom range', range: null }
    ];


    const [toggle, setToggle] = useState(false);

    const [dateRange, setDateRange] = useState(null);
    const [tempRange, setTempRange] = useState(null);
    const [activePresetId, setActivePresetId] = useState(props.activePresentId);
    // const [selectedRange, setSelectedRange] = useState(RANGE_DATA.find(p => p.id === activePresetId)?.label ?? "-");
    const [selectedRange, setSelectedRange] = useState("Select date");

    useEffect(() => {
        if (props.activePresentId) {
            setActivePresetId(props.activePresentId);
        } else {
            setActivePresetId(null)
        }
    }, [props.activePresentId]);

    useEffect(() => {
        if (props.value) {
            setDateRange(props.value);
            setTempRange(props.value);

            setSelectedRange(RANGE_DATA.find(p => p.id === activePresetId)?.label ?? "-");

        }
    }, [props.value]);


    // const handlePresetClick = (preset) => {
    //     setActivePresetId(preset.id);
    //     setTempRange(preset.range);


    //     props.handleChange(preset.range);
    //     setDateRange(preset.range);
    // };

    const handlePresetClick = (preset) => {
        if (Array.isArray(preset.range) && props.maxDate) {
            const [start, end] = preset.range;
            preset = {
                ...preset,
                range: [start, end > props.maxDate ? props.maxDate : end]
            };
        }

        setActivePresetId(preset.id);
        setTempRange(preset.range);
        setDateRange(preset.range);
        props.handleChange(preset.range);
    };


    const handleCalendarChange = (range) => {
        setActivePresetId(6);
        setTempRange(range);


        props.handleChange(range);
        setDateRange(range);
    };


    // const _handleApply = () => {
    //     setToggle(false);
    //     props.handleApply();
    //     setSelectedRange(RANGE_DATA.find(p => p.id === activePresetId)?.label ?? "-")
    // };

    const _handleApply = () => {
        setToggle(false);

        if (activePresetId === 6 && Array.isArray(tempRange)) {
            setSelectedRange(
                `${format(tempRange[0], 'dd MMM, yyyy')} - ${format(tempRange[1], 'dd MMM, yyyy')}`
            );
        } else {
            setSelectedRange(
                RANGE_DATA.find(p => p.id === activePresetId)?.label ?? "-"
            );
        }

        props.handleApply?.();
    };


    const _handleCancel = () => {
        // setTempRange([startOfMonth(today), endOfMonth(today)]);
        setToggle(false);
    };

    return (
        <div className="e-range-picker position-relative">

            <div className={`${props.className} e-border-1px-indigo bg-transparent p-2 e-border-radius-12 cursor-pointer`}
                onClick={() => setToggle(true)}
            >
                {dateRange ? (
                    <div className='d-flex align-items-center gap-2'>
                        <p className="mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-600 line-height-24px">
                            {selectedRange}
                        </p>
                        <Icon
                            icon="arrow"
                            size="12px"
                            color="#212121"
                            className="transform-rotate-90"
                        />
                    </div>
                ) : (
                    <div className='d-flex align-items-center gap-2 justify-content-between '>
                        <div className='d-flex align-items-center gap-2'>
                            <img src={require("../../Assets/Image/CountryAdmin/Notification/calendar-icon.svg").default}
                                draggable={false}
                                alt='calender-icon' />
                            <p className="mb-0 e-text-davys-grey-light">
                                {props.placeholder || 'Select date range'}
                            </p>
                        </div>
                        <Icon
                            icon="arrow"
                            size="12px"
                            color="#212121"
                            className="transform-rotate-90"
                        />
                    </div>

                )}
            </div>

            {toggle && (
                <>
                    <OverLay isOpen={toggle} onClose={_handleCancel} />

                    <div className={`${style.e_range_box_wrapper} position-absolute z-index-99 e-bg-white e-border-radius-8 end-0 top-46px`}
                        style={{ width: '464px' }}>

                        <div className="d-flex "
                        >

                            {/* Presets */}
                            <div className="p-3 e-border-right-1px-snow-white" style={{ width: '180px' }}>
                                {RANGE_DATA.map((preset) => (
                                    <div
                                        key={preset.id}
                                        className={`w-100 text-start mb-2 e-font-14 e-border-radius-40 padding-6px-tb padding-12px-lr
                                        ${activePresetId === preset.id ? 'e-bg-lust e-text-white cursor-pointer' : 'e-bg-black-haze e-text-raisin-black cursor-pointer'}`}
                                        onClick={() => handlePresetClick(preset)}
                                    >
                                        <span className=' e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                            {preset.label}
                                        </span>
                                    </div>
                                ))}
                            </div>

                            {/* Calendar */}
                            <div className="p-3 " style={{ width: "284px" }}>
                                <Calendar
                                    selectRange
                                    value={tempRange}
                                    maxDate={props.maxDate}
                                    minDate={props.minDate}
                                    prev2Label={null}
                                    next2Label={null}
                                    formatShortWeekday={(locale, date) =>
                                        date.toLocaleDateString(locale, { weekday: 'short' })
                                    }
                                    onChange={handleCalendarChange}
                                />


                            </div>
                        </div>

                        {tempRange && (
                            <div className="d-flex justify-content-between align-items-center px-3 pb-3 e-border-top-1px-snow-white padding-12px-top">
                                <p className="mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-500 line-height-20px">
                                    {format(tempRange[0], 'dd MMM, yyyy')} -{' '}
                                    {format(tempRange[1], 'dd MMM, yyyy')}
                                </p>

                                <div className="d-flex gap-2">
                                    <SecondaryButton name="Cancel"
                                        className="py-1 padding-20px-lr e-border-radius-8 w-84px"
                                        onPress={_handleCancel}
                                    />
                                    <PrimaryButton name="Apply"
                                        disabled={!Array.isArray(tempRange)}
                                        className="py-1 padding-20px-lr e-border-radius-8 w-84px"
                                        onPress={_handleApply}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default DateRangePicker;
